import { IconType } from 'react-icons/lib';

const ClosedJobIcon: React.FC<{ color?: string; height?: number; width?: number }> = ({
  color,
  height = 24,
  width = 24,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 33 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="16.5" cy="16" r="16" fill="#00B4D8" />
    <g clipPath="url(#clip0_1003_15487)">
      <path
        d="M17 25C19.3869 25 21.6761 24.0518 23.364 22.364C25.0518 20.6761 26 18.3869 26 16C26 13.6131 25.0518 11.3239 23.364 9.63604C21.6761 7.94821 19.3869 7 17 7C14.6131 7 12.3239 7.94821 10.636 9.63604C8.94821 11.3239 8 13.6131 8 16C8 18.3869 8.94821 20.6761 10.636 22.364C12.3239 24.0518 14.6131 25 17 25ZM14.1523 13.1523C14.4828 12.8219 15.0172 12.8219 15.3441 13.1523L16.9965 14.8047L18.6488 13.1523C18.9793 12.8219 19.5137 12.8219 19.8406 13.1523C20.1676 13.4828 20.1711 14.0172 19.8406 14.3441L18.1883 15.9965L19.8406 17.6488C20.1711 17.9793 20.1711 18.5137 19.8406 18.8406C19.5102 19.1676 18.9758 19.1711 18.6488 18.8406L16.9965 17.1883L15.3441 18.8406C15.0137 19.1711 14.4793 19.1711 14.1523 18.8406C13.8254 18.5102 13.8219 17.9758 14.1523 17.6488L15.8047 15.9965L14.1523 14.3441C13.8219 14.0137 13.8219 13.4793 14.1523 13.1523Z"
        fill={color ?? 'white'}
      />
    </g>
    <defs>
      <clipPath id="clip0_1003_15487">
        <rect width="18" height="18" fill="white" transform="translate(8 7)" />
      </clipPath>
    </defs>
  </svg>
);

const CloseJobIcon: IconType = () => <ClosedJobIcon color="currentColor" />;

export default ClosedJobIcon;
export { CloseJobIcon };
